
import {
  computed,
  defineComponent, onMounted, onUnmounted, ref, Ref,
} from 'vue';
// eslint-disable-next-line import/no-cycle
import { useRoute } from 'vue-router';
import { useDriveStore } from '../../store/driveStore';
import { useMainStore } from '@/store/mainStore';
import { HIDE_BORDER, CASE_VIEW_NAVIGATION } from '@/types/enums';
import DriveFiles from '../UI/DriveFiles.vue';
import NativeService from '@/services/NativeService';

export default defineComponent({
  emits: ['viewInfo'],
  props: {
    isPreviewCase: { type: Boolean, default: false },
  },
  components: {
    DriveFiles,
  },
  setup(props) {
    const driveStore = useDriveStore();
    const mainStore = useMainStore();
    const route = useRoute();

    const itemHeight: Ref<string> = ref('');
    const itemMargin: Ref<string> = ref('');
    const spacer: Ref<HTMLElement | null> = ref(null);
    const currentSubpage = ref<CASE_VIEW_NAVIGATION>(CASE_VIEW_NAVIGATION.OVERVIEW);

    const isNetwork = computed(() => route.meta.isNetwork);

    function onResize() {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      itemHeight.value = `${spacer.value!.offsetWidth * 0.7}px`;
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      itemMargin.value = `${(spacer.value!.offsetWidth * 5) / 30 + 16}px`;
    }

    function openFile(file) {
      const isPDF = computed(() => file.name?.includes('.pdf'));
      const fileUrl = computed(() => (process.env.VUE_APP_MEDIA_URL || '') + file.fileUrl);
      // callback for native app
      if (isPDF.value && mainStore.isMobile) {
        NativeService.getPdfUrl(fileUrl.value);
        return;
      }
      if (isPDF.value && !mainStore.isMobile) {
        window.open(fileUrl.value, '_blank');
        return;
      }
      driveStore.appPhotoViewMedia = file;
    }

    onMounted(() => {
      window.addEventListener('resize', onResize);
      onResize();
    });

    onUnmounted(() => {
      window.removeEventListener('resize', onResize);
    });

    return {
      isNetwork,
      driveStore,
      itemHeight,
      itemMargin,
      spacer,
      HIDE_BORDER,
      openFile,
      currentSubpage,
      CASE_VIEW_NAVIGATION,
      mainStore,
    };
  },
});
